<template>
  <a-card class="style1 m-4">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="First Name">
        <a-input size="large" placeholder="First name" v-decorator="['first_name', { rules: [{ required: true, message: 'Please input first name!' }] }]" />
      </a-form-item>
      <a-form-item label="Last Name">
        <a-input size="large" placeholder="Last name" v-decorator="['last_name', { rules: [{ required: true, message: 'Please input last name!' }] }]" />
      </a-form-item>
      <a-form-item label="Email">
        <a-input size="large" placeholder="Email" v-decorator="['email', { rules: [{ required: true, message: 'Please input email!' }] }]" />
      </a-form-item>
      <a-form-item label="Role">
        <a-checkbox-group v-decorator="['role']" :options="roleInfo" />
      </a-form-item>
      <a-form-item label="Password">
        <a-input size="large" placeholder="Password" v-decorator="['password', { rules: [{ required: true, message: 'Please input password!' }] }]" />
      </a-form-item>
      <a-form-item label="Cell phone">
        <a-input size="large" placeholder="Cell phone" v-decorator="['cell_phone', { rules: [{ required: true, message: 'Please input cell phone!' }] }]" />
      </a-form-item>
      <a-form-item label="Church Name">
        <a-input size="large" placeholder="Church Name" v-decorator="['church_name', { rules: [{ required: true, message: 'Please input church name!' }] }]" />
      </a-form-item>
      <a-form-item label="Recurly Code">
        <a-input size="large" placeholder="Recurly Code" v-decorator="['recurly_code', { rules: [{ required: true, message: 'Please input recurly code!' }] }]" />
      </a-form-item>
      <a-form-item label="Street">
        <a-input size="large" placeholder="Street" v-decorator="['street', { rules: [{ required: true, message: 'Please input street!' }] }]" />
      </a-form-item>
      <a-form-item label="City">
        <a-input size="large" placeholder="City" v-decorator="['city', { rules: [{ required: true, message: 'Please input city!' }] }]" />
      </a-form-item>
      <a-form-item label="State">
        <a-input size="large" placeholder="State" v-decorator="['state', { rules: [{ required: true, message: 'Please input state!' }] }]" />
      </a-form-item>
      <a-form-item label="Zipcode">
        <a-input size="large" placeholder="Zipcode" v-decorator="['zipcode', { rules: [{ required: true, message: 'Please input zipcode!' }] }]" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 24 }">
        <a-tag color="red" class="w-100 p-1" v-if="!empty(error)">{{ error }}</a-tag>
        <a-button type="primary" html-type="submit" :loading="isLoading">Submit</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import AdminService from '@/services/AdminService';
import { empty } from '@/utils';
import { get, map } from 'lodash';
export default {
  data() {
    const roleInfo = [
      { text: 'Admin', value: 'admin' },
      { text: 'Care', value: 'care' },
      { text: 'Disciple', value: 'disciple' },
      { text: 'Evangelism', value: 'evangelism' },
      { text: 'Individual', value: 'individual' },
    ];
    return {
      form: this.$form.createForm(this),
      error: '',
      isLoading: false,
      roleInfo: map(roleInfo, item => ({ label: item.text, value: item.value })),
    };
  },

  methods: {
    empty,
    async handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.error = '';
            this.isLoading = true;
            const resp = await AdminService.account.create(values);
            console.log({ resp });
            this.$notification['success']({
              message: 'New account created successful.',
            });
          } catch (error) {
            console.error({ error });
            this.error = get(error, 'response.data.error', error.message);
            this.$notification['error']({
              message: error.response.status,
              description: this.error,
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>
